<template>
  <form @submit.prevent="setFilters" class="rounded border bg-white py-2 shadow-md w-64">
    <ul>
      <li
        class="px-4 py-2 select-none hover:bg-indigo-500 group"
        @click="activeSubMenu = activeSubMenu ? null : 'tags'"
      >
        <div class="flex items-baseline">
          <div class="flex-1 group-hover:text-white">
            Tags <template v-if="selectedTags.length"> ({{ selectedTags.length }}) </template>
          </div>
          <div
            v-if="selectedTags.length"
            class="flex-none text-indigo-500 group-hover:text-white cursor-pointer"
            @click.stop
          >
            <div @click="clearTags" class="uppercase text-sm">Clear</div>
          </div>
        </div>
      </li>
      <li
        v-if="activeSubMenu === 'tags'"
        class="text-sm overflow-y-auto px-2 my-2 border-t border-b bg-gray-200"
        :style="{ maxHeight: '16rem' }"
      >
        <ul>
          <li v-for="(tags, category, index) in tagByCategory" :key="`tags_${index}`">
            <div class="px-4 py-2 select-none text-gray-600 uppercase">
              {{ category }}
            </div>
            <ul class="-my-1">
              <li v-for="tag in tags" :key="`tag_${tag.id}`">
                <div class="flex items-baseline">
                  <div
                    class="flex-1 px-4 py-2 select-none rounded my-1"
                    :class="{
                      'bg-indigo-500 hover:bg-indigo-600 text-white': tagExists(tag.id),
                      'hover:bg-indigo-500 hover:text-white': !tagExists(tag.id),
                    }"
                    @click="setTags(tag.id)"
                  >
                    {{ tag.name }}
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li class="px-2 pt-2 select-none flex justify-between">
        <BaseLinkButton silver @click="clearAll"> clear </BaseLinkButton>
        <BaseLinkButton green @click="setFilters"> apply </BaseLinkButton>
      </li>
    </ul>
  </form>
</template>

<script>
import { groupBy } from 'lodash-es';
import { entityComputed } from '@/store/helper';

export default {
  name: 'Filters',
  data: () => ({
    tagsVisible: false,
    selectedFilters: {
      tags: [],
    },
    activeSubMenu: null,
  }),
  computed: {
    ...entityComputed,
    tagByCategory() {
      return groupBy(this.$store.state.entities.tags.byId, 'category');
    },
    selectedTags() {
      return this.selectedFilters.tags.map((id) => this.entityById('tags', id).name);
    },
  },
  methods: {
    setTags(tagId) {
      const index = this.selectedFilters.tags.indexOf(tagId);
      const exists = index > -1;

      if (exists) {
        this.selectedFilters.tags.splice(index, 1);
      } else {
        this.selectedFilters.tags.push(tagId);
      }
    },
    clearTags() {
      this.selectedFilters.tags = [];
    },
    clearAll() {
      this.clearTags();
    },
    tagExists(tagId) {
      return this.selectedFilters.tags.indexOf(tagId) > -1;
    },
    setFilters() {
      const filters = [];
      const { tags } = this.selectedFilters;
      if (tags.length) filters.push({ tag: tags.join(',') });
      this.$emit('changed', { filters });
      this.clearAll();
    },
  },
};
</script>
